import React, { useCallback, useState, useRef, useEffect } from 'react';
import { useHistory, Link } from "react-router-dom";
import { connect } from "react-redux";
import { Button } from 'devextreme-react/button';
import AccordionReact from 'devextreme-react/accordion';
import FormField from '../../../../dynamicFormBuilder/FormField';
import { GridLayout } from "../../../../common/GridLayout";
import { FillFilters, getAppSettings } from '../../../../common/Utils';
import { createStore } from 'devextreme-aspnet-data-nojquery';
import DataSource from "devextreme/data/data_source";
import data from "../../../../assets/apiRoutes.json";
import Toolbar, { Item } from "devextreme-react/toolbar";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar as GridToolbar,
    Item as GridToolbarItem,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
    Lookup,
} from "devextreme-react/data-grid";
import { SearchLayout } from './Layout';
import GridLayoutManager from "../../../../gridLayoutCustomization/GridLayoutManager";
import '../../../../common/css/searchPage.css';

const searchpanel = [
    {
        ID: 1,
        Title: 'Search Filters'
    }
];

const List = (props) => {
    const history = useHistory();
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const DYNAMICFORMSETTING = props.oidc?.user?.profile?.DYNAMICFORMSETTING;
    const formRefs = useRef({});
    // Honor the "Collapse Filter Panel" application setting: collapsed -> no item selected,
    // expanded -> the first (and only) search-filter panel is selected.
    const filtersCollapsed = !!getAppSettings()?.FiltersCollapsed;
    const [selectedItems, setSelectedItems] = useState(filtersCollapsed ? [] : [searchpanel[0]]);
    const [searchPanelStatus, setSearchPanelStatus] = useState(false);
    const [isEditButtonDisabled, setIsEditButtonDisabled] = useState(true);
    const rowId = useRef(null);
    const dataGrid = useRef(null);

    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "6E2B4A17-9C83-4F51-B0D6-3A7C1E9F5B24";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const initialFormFields = {
        code: '',
        description1: '',
        description2: '',
        status: ''
    };
    const [formFields, setformFields] = useState(initialFormFields);
    const formFieldsRef = useRef(formFields);

    const statusOptions = [
        { id: 'A', text: 'Active' },
        { id: 'I', text: 'Inactive' }
    ];

    const loadLookupClient = useCallback((name, dataSource, valueExpr = 'id', displayExpr = 'text') => {
        const ref = formRefs.current?.[name];
        if (!ref?.instance) return;

        ref.instance().option('dataSource', dataSource);
        ref.instance().option('valueExpr', valueExpr);
        ref.instance().option('displayExpr', displayExpr);
    }, []);

    useEffect(() => {
        formFieldsRef.current = formFields;
    }, [formFields]);

    const selectionChanged = useCallback(
        (e, tg) => {
            let newItems = [...selectedItems];
            e.removedItems.forEach((item) => {
                const index = newItems.indexOf(item);
                if (index >= 0) {
                    newItems.splice(index, 1);
                }
            });
            if (e.addedItems.length) {
                newItems = [...newItems, ...e.addedItems];
            }
            setSelectedItems(newItems);
            setSearchPanelStatus((prevStatus) => {
                const newStatus = !prevStatus;
                return newStatus;
            });
        },
        [selectedItems, setSelectedItems],
    );

    const onSelectionChanged = ({ selectedRowsData }) => {
        if (selectedRowsData && selectedRowsData.length === 1) {
            rowId.current = selectedRowsData[0].RowId;
            setIsEditButtonDisabled(false);
        } else {
            rowId.current = null;
            setIsEditButtonDisabled(true);
        }
    };

    const handleEditClick = () => {
        const buttonUrl = "/wm/codes/edit-exception?id=" + rowId.current;
        history.push(buttonUrl);
    };

    const handleSearch = (e) => {
        e.event.stopPropagation();
        let datasource = loadDatasource();

        const filters = FillFilters(formFields);

        if (filters.length === 0) {
            datasource.filter(null);
        }

        datasource.filter(filters);
        setResultData(datasource);
    };

    const handleReset = (e) => {
        e.event.stopPropagation();
        setformFields(initialFormFields);
        setTimeout(() => {
            setResultData(loadDatasource());
        }, 100);
    };

    const handleFormLoad = useCallback(() => {
        setTimeout(() => {
            loadLookupClient("status", statusOptions);
        }, 100);
    }, [loadLookupClient]);

    const handleFieldChange = useCallback((name, value) => {
    }, []);

    useEffect(() => {
        if (!resultData) {
            setResultData(loadDatasource());
        }
    }, []);

    const loadDatasource = () => {
        let store = createStore({
            key: 'RowId',
            loadUrl: `${window._env_.REACT_APP_APIS}/${data.Exceptions.GetExceptionHeaders}`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        });
        const dataSource = new DataSource({ store: store });
        return dataSource;
    };

    const [resultData, setResultData] = useState(null);

    return (
        <div className="search-page-container">
            <div className="search-page-content">
                <div id="accordion" className="search-page-accordion">
                    <AccordionReact
                        dataSource={searchpanel}
                        collapsible={true}
                        multiple={false}
                        animationDuration={300}
                        selectedItems={selectedItems}
                        onSelectionChanged={e => {
                            if (e.currentTarget === e.target) {
                                selectionChanged(e, e.target);
                            }
                        }}
                        itemTitleRender={() => (
                            <Toolbar className="accordian-toolbar">
                                <Item location="before">
                                    <div className="title">
                                        <h6
                                            style={{
                                                color: window._env_.Color2
                                            }}
                                        >
                                            Enter Your Query For Warehouse Exceptions
                                        </h6>
                                    </div>
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleSearch} text="Search" type="default" />
                                </Item>
                                <Item location="after">
                                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                                </Item>
                            </Toolbar>
                        )}
                        itemRender={(itemProps) => (
                            <FormField
                                currrentUser={currentUser}
                                layoutId='1D9F4C82-5A63-4E27-B1A0-7C3E8D6F2B95'
                                layoutName='WMExceptionSearchForm'
                                defaultFormSchema={SearchLayout}
                                formFields={formFields}
                                setformFields={setformFields}
                                handleFieldValueChange={handleFieldChange}
                                DYNAMICFORMSETTING={DYNAMICFORMSETTING}
                                formRefs={formRefs}
                                onFormLoad={handleFormLoad}
                                noSpacingBeforeFirstRow={true}
                            />
                        )}
                        id="accordion-container" className="accordion-height"
                    />
                </div>
                <div className="search-page-grid-container">
                    <DataGrid
                        onExporting={(e) => {
                            if (window.handleDevExtremeDataGridExport) {
                                window.handleDevExtremeDataGridExport(e);
                            }
                        }}
                        ref={dataGrid}
                        allowColumnReordering={true}
                        allowColumnResizing={true}
                        dataSource={resultData}
                        showBorders={true}
                        hoverStateEnabled={true}
                        className="search-page-grid"
                        onSelectionChanged={(e) => onSelectionChanged(e)}
                        remoteOperations={true}
                        searchEnabled={true}
                        columnAutoWidth={true}
                    >
                        <ColumnChooser
                            enabled={true}
                            title="Choose Column"
                            width={290}
                            height={290}
                            sortOrder="asc"
                        >
                            <ColumnChooserSearch
                                enabled={true}
                                editorOptions={{ placeholder: 'Search column' }} />
                        </ColumnChooser>
                        <Export enabled={true} allowExportSelectedData={true} />
                        <Selection mode="multiple" />
                        <Sorting visible={true} mode="multiple" />
                        <Paging defaultPageSize={10} />
                        <Pager
                            visible={true}
                            showPageSizeSelector={true}
                            allowedPageSizes={allowedPageSizes}
                            showNavigationButtons={true}
                        />
                        <FilterRow visible={true} />
                        <FilterPanel visible={true} />
                        <GroupPanel visible={true} />
                        <Grouping autoExpandAll={false} />
                        <StateStoring
                            enabled={true}
                            type="custom"
                            customLoad={loadState}
                            storageKey={gridKey}
                            customSave={saveState}
                        />
                        <GridToolbar>
                            <GridToolbarItem location="before">
                                <Button
                                    disabled={isEditButtonDisabled}
                                    onClick={handleEditClick}
                                    type="default"
                                    text="Edit"
                                ></Button>
                            </GridToolbarItem>
                            <GridToolbarItem location="before">
                                <div>
                                    <Link to="/wm/codes/add-exception">
                                        <Button
                                            type="default"
                                            className="gridTopButton"
                                            text="Create"
                                        ></Button>
                                    </Link>
                                </div>
                            </GridToolbarItem>
                            <GridToolbarItem location="after">
                                <GridLayoutManager
                                    gridKey={gridKey}
                                    dataGrid={dataGrid}
                                    currentLayout={currentLayout}
                                    setCurrentLayout={setCurrentLayout}
                                    accessToken={accessToken}
                                />
                            </GridToolbarItem>
                            <GridToolbarItem name="columnChooserButton" />
                            <GridToolbarItem name="exportButton" />
                        </GridToolbar>
                        <Column dataType="string" caption="Record #" dataField="RecordNumber" />
                        <Column dataType="string" caption="Code" dataField="Code" />
                        <Column dataType="string" caption="Status" dataField="Status">
                            <Lookup
                                dataSource={[{ id: 'A', text: 'Active' }, { id: 'I', text: 'Inactive' }]}
                                displayExpr="text"
                                valueExpr="id" />
                        </Column>
                        <Column dataType="string" caption="Description 1" dataField="Description1" />
                        <Column dataType="string" caption="Description 2" dataField="Description2" />
                        <Column dataType="string" caption="Code 1" dataField="UserDefinedCode1" visible={false} />
                        <Column dataType="string" caption="Code 2" dataField="UserDefinedCode2" visible={false} />
                        <Column dataType="string" caption="Code 3" dataField="UserDefinedCode3" visible={false} />
                        <Column dataType="string" caption="Code 4" dataField="UserDefinedCode4" visible={false} />
                        <Column dataType="string" caption="Code 5" dataField="UserDefinedCode5" visible={false} />
                        <Column dataType="date" caption="Date 1" dataField="UserDefinedDate1" visible={false} />
                        <Column dataType="date" caption="Date 2" dataField="UserDefinedDate2" visible={false} />
                        <Column dataType="date" caption="Date 3" dataField="UserDefinedDate3" visible={false} />
                        <Column dataType="date" caption="Date 4" dataField="UserDefinedDate4" visible={false} />
                        <Column dataType="date" caption="Date 5" dataField="UserDefinedDate5" visible={false} />
                        <Column dataType="number" caption="Quantity 1" dataField="UserDefinedQuantity1" visible={false} />
                        <Column dataType="number" caption="Quantity 2" dataField="UserDefinedQuantity2" visible={false} />
                        <Column dataType="number" caption="Quantity 3" dataField="UserDefinedQuantity3" visible={false} />
                        <Column dataType="number" caption="Quantity 4" dataField="UserDefinedQuantity4" visible={false} />
                        <Column dataType="number" caption="Quantity 5" dataField="UserDefinedQuantity5" visible={false} />
                        <Column dataType="string" caption="Reference 1" dataField="UserDefinedReference1" visible={false} />
                        <Column dataType="string" caption="Reference 2" dataField="UserDefinedReference2" visible={false} />
                        <Column dataType="string" caption="Reference 3" dataField="UserDefinedReference3" visible={false} />
                        <Column dataType="string" caption="Reference 4" dataField="UserDefinedReference4" visible={false} />
                        <Column dataType="string" caption="Reference 5" dataField="UserDefinedReference5" visible={false} />
                    </DataGrid>
                </div>
            </div>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        oidc: state.oidc
    };
}

export default connect(mapStateToProps)(List);
